// import "./assets/css/reset.css";
// import "./assets/css/bootstrap.min.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/css/wise.css";
// import "./assets/css/quill.snow.css";
// import "./assets/css/CustomReactQuill.css";

import React, { lazy, Suspense, useEffect } from "react";
import { UserProvider } from "./state/context/UserContext";
import { SearchProvider } from "./state/context/SearchContext";
import { PageProvider } from "./state/context/PageContext";
import { ShoppingProvider } from "./state/context/ShoppingContext";
import { IdleTimeoutProvider } from "./state/context/IdleTimeoutContext";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { getAppBasePath } from "./utils/appPath";

import { v4 as uuidv4 } from "uuid";
const NotFound = lazy(() => import("./pages/NotFound"));
const ProductOverview = lazy(
  () => import("./pages/ProductOverview/ProductOverview"),
);
const DefaultPage = lazy(() => import("./pages/DefaultPage/DefaultPage"));
const Register = lazy(() => import("./pages/Register/Register"));
const Login = lazy(() => import("./pages/Login/Login"));
const ForgotPassword = lazy(
  () => import("./pages/ForgotPassword/ForgotPassword"),
);
const MemberProfile = lazy(() => import("./pages/MemberProfile/MemberProfile"));
const MemberCenter = lazy(() => import("./pages/MemberProfile/MemberCenter"));
const OrderDetail = lazy(() => import("./pages/MemberProfile/OrderDetail"));
const ResetPassword = lazy(() => import("./pages/ResetPassword/ResetPassword"));
const CheckoutPageV2 = lazy(() => import("./pages/ShoppingCar/CheckoutPageV2"));
const FinalCheckout = lazy(() => import("./pages/ShoppingCar/FinalCheckout"));
const OrderComplete = lazy(() => import("./pages/ShoppingCar/OrderComplete"));

export const getOrCreateUserUUID = () => {
  const key = "shopping_userid";
  let uuid = localStorage.getItem(key);

  if (!uuid) {
    uuid = uuidv4();
    localStorage.setItem(key, uuid);
  }

  return uuid;
};
const userUUID = getOrCreateUserUUID();

// Google 搜尋會自動加上 srsltid 等追蹤參數，載入時清除
const TRACKING_PARAMS = [
  "srsltid",
  "gclid",
  "fbclid",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

function App() {
  useEffect(() => {
    const url = new URL(window.location.href);
    let changed = false;
    TRACKING_PARAMS.forEach((p) => {
      if (url.searchParams.has(p)) {
        url.searchParams.delete(p);
        changed = true;
      }
    });
    if (changed) {
      window.history.replaceState(
        null,
        "",
        url.pathname + url.search + url.hash,
      );
    }
  }, []);

  return (
    <IdleTimeoutProvider>
      <ShoppingProvider userId={userUUID}>
        <SearchProvider>
          <UserProvider>
            <PageProvider>
              <Router basename={getAppBasePath()}>
                <Suspense fallback={null}>
                  <Routes>
                    <Route path="/" element={<DefaultPage />} />
                    <Route
                      path="DefaultPage/:menuId"
                      element={<DefaultPage />}
                    />
                    <Route
                      path="DefaultPage/TagName/:menuId"
                      element={<DefaultPage />}
                    />
                    <Route
                      path="DefaultPage/TagName/FromMenu/:tagName2"
                      element={<DefaultPage />}
                    />
                    <Route
                      path="DefaultPage/TagId/:tagId"
                      element={<DefaultPage />}
                    />
                    <Route
                      path="DefaultPage/TagId/FromMenu/:tagId"
                      element={<DefaultPage />}
                    />
                    <Route
                      path="DefaultPage/ProductOverviewDetail/:menuId"
                      element={<DefaultPage />}
                    />
                    <Route
                      path="DefaultPage/Checkout"
                      element={<DefaultPage />}
                    />
                    <Route
                      path="ProductOverview"
                      element={<ProductOverview />}
                    />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route
                      path="/forgot-password"
                      element={<ForgotPassword />}
                    />
                    <Route path="/member/register" element={<Register />} />
                    <Route path="/Login" element={<Login />} />
                    <Route path="/member/profile" element={<MemberProfile />} />
                    {/* <Route path="/member/center" element={<MemberCenter />} /> */}
                    <Route
                      path="DefaultPage/MemberCenter"
                      element={<DefaultPage />}
                    />
                    <Route
                      path="DefaultPage/OrderDetail/:orderId"
                      element={<DefaultPage />}
                    />
                    <Route
                      path="/member/orders/:orderId"
                      element={<OrderDetail />}
                    />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Suspense>
              </Router>
            </PageProvider>
          </UserProvider>
        </SearchProvider>
      </ShoppingProvider>
    </IdleTimeoutProvider>
  );
}

export default App;
